module.exports = __webpack_public_path__ + "img/5.ded80b65.jpg";